import { useQuery, useQueryClient } from "@tanstack/react-query";
import { __Post, __PostForm } from "request/Petitions/__Post";
import environment from "constants/apiConst";

// Hook para obtener datos de pesajes
export const useWeighIns = (token, page = 1, enabled = true) => {
  return useQuery({
    queryKey: ["weighIns", page],
    queryFn: async () => {
      const dataWeighing = new FormData();
      dataWeighing.append("order", "desc");
      dataWeighing.append("scale", true);
      dataWeighing.append("page", page);
      
      const res = await __PostForm(
        environment.TREASURY_WEIGHING,
        token,
        dataWeighing
      );
      
      return {
        data: res?.data?.status?.data.data || [],
        lastPage: res?.data?.status?.data?.last_page || 1,
        total: res?.data?.status?.data?.total || 0
      };
    },
    enabled: enabled && !!token,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos (antes cacheTime)
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};

// Hook para búsqueda de pesajes usando useQuery
export const useWeighInsSearch = (token, searchData, page = 1, enabled = false) => {
  return useQuery({
    queryKey: ["weighInsSearch", searchData, page],
    queryFn: async () => {
      if (!searchData || Object.keys(searchData).length === 0) {
        throw new Error("No hay datos de búsqueda");
      }

      const res = await __Post(
        environment.TREASURY_WEIGHING,
        token,
        {
          ...searchData,
          page
        }
      );
      
      if (res?.data?.status?.message === "Acceso no autorizado.") {
        throw new Error("Acceso no autorizado.");
      }
      
      return {
        data: res?.data?.status?.data.data || [],
        lastPage: res?.data?.status?.data?.last_page || 1,
        total: res?.data?.status?.data?.total || 0,
        message: res?.data?.status?.message
      };
    },
    enabled: enabled && !!token && !!searchData && Object.keys(searchData).length > 0,
    staleTime: 2 * 60 * 1000, // 2 minutos para búsquedas
    gcTime: 5 * 60 * 1000, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 1, // Menos reintentos para búsquedas
    retryDelay: 1000
  });
};

// Hook para invalidar cache cuando sea necesario
export const useInvalidateWeighIns = () => {
  const queryClient = useQueryClient();
  
  const invalidateAll = () => {
    queryClient.invalidateQueries({ queryKey: ["weighIns"] });
  };
  
  const invalidatePage = (page) => {
    queryClient.invalidateQueries({ queryKey: ["weighIns", page] });
  };
  
  const removeAll = () => {
    queryClient.removeQueries({ queryKey: ["weighIns"] });
  };
  
  return {
    invalidateAll,
    invalidatePage,
    removeAll
  };
};
